import {Order, orderDecoder} from './Order'
import {BpsUser, bpsUserDecoder} from './BpsUser'
import {Customer, customerDecoder} from './Customer'
import {Company, companyDecoder} from './Company'
import {Decoder, field, object} from 'json-bouncer'

export interface OrderWithOwners {
    order: Order
    bpsUser: BpsUser
    customer: Customer
    company: Company
}

export function orderWithOwnersDecoder(): Decoder<OrderWithOwners> {
    return object({
        order: field('order', orderDecoder()),
        bpsUser: field('bpsUser', bpsUserDecoder()),
        customer: field('customer', customerDecoder()),
        company: field('company', companyDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OrderWithOwners.ts